export interface ScreenshotResponse {
  open: boolean;
  xCoordinate: number;
  yCoordinate: number;
  image: string;
}

export const DOM_ELEMENTS = {
  div: 'div',
  gridsterItem: 'gridster-item',
  globalFilters: 'od-global-filters',
  globalFilterTouchable: 'global-filter-touchable',
  kpiTouchable: 'kpi-touchable',
  orKpiBox: 'od-kpi-box',
  iFrame: 'iframe',
};
